export const locale = {
  'DIALOG' : {
    'CREATETYPE' : {
      'TITLE' : {
        'CREATE' : 'Создать группу',
        'EDIT' : 'Изменить группу',
      },
      'CONFIRMBUTTON' : {
        'CREATE' : 'Создать',
        'SAVE' : 'Сохранить',
      },
      'NAME' : 'Название группы',
    },
  },
};
